<template>
  <div>
    <modal name="BoardPopup" width="1024px" height="auto" :scrollable="true" :clickToClose="false">
      <div id="News_popup">
        <div class="popup_bar">
          <h4 v-if="!EDIT_MODE">{{boardTitle}} 게시물 추가</h4>
          <h4 v-if="EDIT_MODE">{{ boardTitle }} 게시물 수정</h4>
          <a @click="btnClose" class="btn_close"></a>
        </div>

        <ul class="contents">
          <li class="tit">제목</li>
          <li class="tit_input">
            <input type="text" v-model="title" />
          </li>
          <div v-if="this.$route.query.type != 0">
            <li class="tit" style="vertical-align: top; line-height: 21px;">메인 이미지</li>
            <li class="tit_input">
              <file-upload
                input-id="uploadBg"
                ref="upload1"
                v-model="bgImage"
                :drop="true"
                :multiple="false"
              >
                <h4>첨부하실 파일을 선택하거나 마우스로 끌어서 넣어주세요.</h4>
                <h4>※ 메인이미지</h4>
              </file-upload>
            </li>
          </div>


          <li>
            <div v-if="bgImage.length">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>파일이름</th>
                    <th>크기</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="fileObj in bgImage" :key="fileObj.id">
                    <td>
                      <img v-if="fileObj.thumb" :src="fileObj.thumb" width="40" height="auto" />
                      <img v-else :src="fileIcon(fileObj.name)" width="40" height="auto" />
                    </td>
                    <td>{{ fileObj.name }}</td>
                    <td>{{ fileObj.size | formatSize }}</td>
                    <td>
                      <button @click="deleteBgFile(fileObj)">삭제</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </li>

          <!-- <li>내용</li> -->
          <li class="editor">
            <vue-editor v-model="content"></vue-editor>
            <div>컨텐츠 크기 {{ this.content.length | formatSize }}</div>

          </li>
        </ul>

        <ul>
          <li class="input">
            <file-upload
              input-id="dnFiles"
              ref="upload2"
              v-model="dnFiles"
              :drop="true"
              :multiple="true"
            >
              <h4>첨부하실 파일을 선택하거나 마우스로 끌어서 넣어주세요.</h4>
              <h4>※ 다운로드용 파일 입니다.</h4>
            </file-upload>

            <div v-if="dnFiles.length">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>파일이름</th>
                    <th>크기</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="fileObj in dnFiles" :key="fileObj.id">
                    <td>
                      <img v-if="fileObj.thumb" :src="fileObj.thumb" width="40" height="auto" />
                      <img v-else :src="fileIcon(fileObj.name)" width="40" height="auto" />
                    </td>
                    <td>{{ fileObj.name }}</td>
                    <td>{{ fileObj.size | formatSize }}</td>
                    <td>
                      <button @click.prevent="$refs.upload2.remove(fileObj)">삭제</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </li>

        </ul>

        <p class="btn_area">
          <button class="btn_link" @click="btnSave">저장</button>
          <button class="btn_link type02" @click="btnClose">취소</button>
        </p>
      </div>
    </modal>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import FileUpload from "vue-upload-component";
import pm from "../common/protocolManager";
import { mapGetters, mapMutations, mapActions } from "vuex";
import eventBus from "../common/eventBus";

import { getThumbIcon } from "../common/util";

export default {
  components: {
    VueEditor,
    FileUpload,
  },
  data: () => ({
    message: "NoticeWritePopup.vue",
    EDIT_MODE: false,
    boardTitle: "",    // 게시물 상단 제목
    title: "",
    content: "",
    bgImage: [],
    dnFiles: [],
    saveBgImage: [],
    saveDnFiles: [],

  }),
  methods: {
    fileIcon(fileName) {
      return getThumbIcon(fileName);
    },
    deleteBgFile(obj) {
      this.bgImage = [];
    },
    deleteFiles(obj) {},
    btnSave() {

      if (this.title.trim() == "") {
        alert("타이틀을 입력하세요");
        return;
      }

      if (this.bgImage.length == 0 && this.EDIT_MODE == false && this.$route.query.type !=0 ) {
        alert("배경 이미지가 필요합니다. ");
        return;
      }

      let formData = new FormData();
      formData.append("type", this.$route.query.type);
      formData.append("title", this.title);
      formData.append("content", this.content);

      // bg image
      for (let i = 0; i < this.bgImage.length; i++) {
        if (typeof this.bgImage[i].file != "undefined") {
          formData.append("bgImage", this.bgImage[i].file);
        }
      }

      for (let i = 0; i < this.dnFiles.length; i++) {
        if (typeof this.dnFiles[i].file != "undefined") {
          formData.append("dnFiles", this.dnFiles[i].file);
        }
      }

      let url = "insertNotice";
      if (this.EDIT_MODE) {
        url = "updateNotice";
        formData.append("_id", this.$route.query.id);
        if (this.saveBgImage.length != 0) {
          formData.append("saveBgImage", JSON.stringify(this.saveBgImage));
        }
        if (this.saveDnFiles.length != 0) {
          formData.append("saveDnFiles", JSON.stringify(this.saveDnFiles));
        }


      }

      pm.fileUpload(url, formData)
        .then((result) => {
          alert("게시판 등록 성공");
          eventBus.$emit("EVENT_CHANGE_BOARD_LIST");

          if (this.EDIT_MODE) {
            eventBus.$emit("EVENT_CHANGE_BOARD_DETAIL");
          }

          this.btnClose();
        })
        .catch((err) => {
          alert("게시판 등록 에러");
          console.log("error = " + err);
        });
    },
    reqDetail() {
      let url = `noticeDetail?id=${this.$route.query.id}`;
      pm.get(url)
        .then((result) => {

          this.title = result.detail.title;
          this.content = result.detail.content;

          this.saveBgImage = result.detail.files.bgImage || [];
          this.saveDnFiles = result.detail.files.dnFiles || [];
        })
        .catch((err) => {
          console.log("btnDetail - error");
        });
    },
    btnClose() {
      console.log("btnClose");
      this.$modal.hide("EventPopup");
      this.$router.go(-1);
    },
  },
  mounted() {
    this.$modal.show("BoardPopup");
  },
  computed: {

  },
  destroyed() {},
  created() {

    console.log("created - " + this.message);

    if (this.$route.query.id) {this.EDIT_MODE = true;
      this.reqDetail();
    }


    if (this.$route.query.type) {

      // 게시판 타입 = 0 : 공지사항, 1 : 소식,
      if (this.$route.query.type == 0) {
        this.boardTitle = '공지사항';
      } else {
        this.boardTitle = '소식';
      }
    } else {
      // 뒤로 가기
    }


  },
};
</script>



// WEBPACK FOOTER //
// src/components/sub02/NoticeWritePopup.vue